import { uiState } from '../state';
import { iFrameSizeListenerFunctions, onIFrameSizeListener } from './helpers/adjustIFrameSize';

const functionsToInsert = iFrameSizeListenerFunctions.map(fn => fn.toString()).join('\n\n');
const onIFrameSizeListenerString = onIFrameSizeListener.toString();

export async function saveChatState(
    chatName: string,
    chatEl: HTMLDivElement,
    width: number,
    projectId: string,
    headContent?: string,
    codeContent?: string,
) {

    const chatConteiner = chatEl.cloneNode(true) as HTMLDivElement;

    const images = Array.from(chatConteiner.querySelectorAll('img') as NodeListOf<HTMLImageElement>);

    let imgData;

    try {
        imgData = await replaceImagesToBase64(images);
    } catch (error) {
        console.info('Some images from the chat cannot be converter to base64 for export');
    }

    const iframes = Array.from(chatConteiner.querySelectorAll('iframe') as NodeListOf<HTMLIFrameElement>);

    for (let iframe of iframes) {
        const srcUrl = iframe.getAttribute('src');

        try {
            const response = await fetch(srcUrl);
            if (!response.ok) {
                console.error(`Error fetching content from ${srcUrl}: ${response.statusText}`);
                continue;
            }

            let htmlContent = await response.text();

            htmlContent = await inlineExternalScripts(htmlContent);

            const frameSrc = iframe.getAttribute('src');

            iframe.removeAttribute('src');
            iframe.setAttribute('srcdoc', `<a style="display:none;" src="${frameSrc}">Open IFrame</a>` + '\n\n' + htmlContent);

            iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin');

            if (frameSrc.indexOf('alan.') > -1 || frameSrc.indexOf('alan-')) {
                const link = document.createElement('a');
                link.href = frameSrc;
                link.target = '_blank';
                link.textContent = 'Open IFrame ↗️';
                link.setAttribute('style', 'display: block; margin-right: 12px; text-align: right;');
                const parent = iframe.parentNode;
                parent.insertBefore(link, iframe);
            }
        } catch (error) {
            console.error(`Failed to fetch or process iframe from ${srcUrl}:`, error);
        }
    }


    const alanMainClass = "alan-" + projectId;

    const newHtmlContent = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <title>Alan Text Chat History</title>
        ${headContent ? headContent : ''}
        <style>
        * {
            box-sizing: border-box;
        }

        .with-svg {
            max-width: 100%;
            width: 100%;
            min-width: 100%;
        }

        .with-svg iframe {
            max-width: 100%;
            width: 100%;
            min-width: 100%;
        }
        body {
            padding:0 !important;
            margin: 0 !important;
            background: #c6cbce;
        }
        .alan-btn__history-chat-header > h1 {
            padding-left: 10px !important;
            color: #000;
        }
        .alan-btn__history-chat-header {
            margin: 0px auto;
            max-width: ${width}px;
            width: ${width}px;
            min-width: ${width}px;
        }
        .alan-history-inner-content {
            margin: 0px auto;
            max-width: ${width}px;
            width: ${width}px;
            min-width: ${width}px;
            height:100%;
            box-shadow: 0px 1px 3px rgba(16, 39, 126, 0.2);
        }

        .alan-btn__chat-incomming-msg-loader-icon {
            display: flex!important;
            align-items: center;
            justify-content: center;
        }
        .alan-btn__stop-response-btn {
            display:none;
        }
        </style>
    </head>
    <body class="alan-btn__history-body">
    <script>
    var imgData = ${JSON.stringify(imgData)};
    
    document.addEventListener('click', (e) => {
        const clickedEl = e.target;
        if (clickedEl.classList.contains('alan-btn__chat-response-imgs-wrapper-right-arrow') || 
            clickedEl.classList.contains('chat-bubble-images__right-arrow')) {
            updateImage(clickedEl, 'right')
        }
        if (clickedEl.classList.contains('alan-btn__chat-response-imgs-wrapper-left-arrow') || 
            clickedEl.classList.contains('chat-bubble-images__left-arrow')) {
            updateImage(clickedEl, 'left')
        }
    });

    function updateImage(clickedEl, direction) {
        const imgWrapper = clickedEl.closest('[data-msg-req-id]');
        let msgReqId = null;
        let imgEl;
        if (imgWrapper) {
            msgReqId = imgWrapper.getAttribute('data-msg-req-id');
            imgEl = imgWrapper.querySelector('img[all-images-urls]');

            if (msgReqId && imgEl && imgData[msgReqId]?.length > 0) {
                const imgsCount = imgData[msgReqId]?.length;
                let currentIndex = +imgWrapper.getAttribute('data-img-index') || 0;

                if (direction === 'left') {
                    currentIndex = (currentIndex === 0) ? imgsCount - 1 : currentIndex - 1;
                } else if (direction === 'right') {
                    currentIndex = (currentIndex === imgsCount - 1) ? 0 : currentIndex + 1;
                }

                imgWrapper.setAttribute('data-img-index', currentIndex);
                imgEl.src = imgData[msgReqId][currentIndex];

                const leftArr = imgWrapper.querySelector('.alan-btn__chat-response-imgs-wrapper-left-arrow, .chat-bubble-images__left-arrow');
                const rightArr = imgWrapper.querySelector('.alan-btn__chat-response-imgs-wrapper-right-arrow, .chat-bubble-images__right-arrow');

                if (leftArr && rightArr) {
                    leftArr.classList.remove('invisible');
                    rightArr.classList.remove('invisible');

                    if (currentIndex === 0) {
                        leftArr.classList.add('invisible');
                    } else if (currentIndex === imgsCount - 1) {
                        rightArr.classList.add('invisible');
                    }
                }
            }
        }
    } 
        
    window.alanCurrentTheme = '${uiState.currentTheme}';
    
    </script>

    <script>
        ${functionsToInsert}
        window.addEventListener("message", ${onIFrameSizeListenerString});
    </script>

        <div class="alan-history-content ${alanMainClass}">
            <div class="alan-btn__history-chat-header">
                <h1>Alan Text Chat History</h1>
            </div>
            <div class="alan-btn__history-chat alan-history-inner-content">
                ${chatConteiner.outerHTML}
            </div>
        </div>
        ${codeContent ? codeContent : ''}
    </body>
    </html>
`;

    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;

    const blob = new Blob([newHtmlContent], { type: 'text/html' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${chatName.replace(/[\s-]/g, "_")}_chat_history_${formattedDate}.html`;
    link.click();
    URL.revokeObjectURL(link.href);
}

async function replaceImagesToBase64(images) {
    const result = {};

    for (let img of images) {
        try {
            const allImagesAttr = img.getAttribute('all-images-urls');
            if (allImagesAttr) {
                const urls = img.getAttribute('all-images-urls').split(',');
                const imgWrapper = img.closest('[data-msg-req-id]');
                let msgReqId = null;
                if (imgWrapper) {
                    msgReqId = imgWrapper.getAttribute('data-msg-req-id');
                }

                if (msgReqId) {
                    const base64Images = await Promise.all(urls.map(url => fetchImageAsBase64(url.trim())));
                    result[msgReqId] = base64Images;
                }
            }

            img.src = await fetchImageAsBase64(img.src);
        } catch (error) {
            console.error(`Error converting images for msgId ${img.getAttribute('msgInd')}:`, error);
        }
    }

    return result;
}

async function fetchImageAsBase64(url) {
    const response = await fetch(url, { mode: 'cors' });
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}

async function inlineExternalScripts(htmlContent) {
    // Create a DOM parser to convert the HTML string to a document
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');

    // Select all script tags with a src attribute in the parsed document
    const scriptTags = Array.from(doc.querySelectorAll('script[src]'));

    for (const scriptTag of scriptTags) {
        const src = scriptTag.getAttribute('src');

        try {
            // Fetch the script content from the source
            const response = await fetch(src);
            const scriptContent = await response.text();

            // Create a new inline script element with the fetched content
            const inlineScript = doc.createElement('script');
            inlineScript.textContent = scriptContent;

            // Replace the original script tag with the new inline script
            scriptTag.parentNode.replaceChild(inlineScript, scriptTag);

            console.log(`Inlined script from ${src}`);
        } catch (error) {
            console.error(`Failed to inline script from ${src}:`, error);
        }
    }

    // Serialize the document back to an HTML string
    return doc.documentElement.outerHTML;
}